import { BareStaffAllocation } from './staffAllocation';
import { BrandSegment, BrandLevel, BrandAttribute, Brand } from './brand';
import { WithId, WithTimestamp } from './typeUtils';
import { Mcm } from './mcm';
import { Audience } from './audience';
import { BasePaginationAndSearch } from './pagination';
import { EventTemplateTranslation } from './translation';
import { BaseTranslationAggregationParams } from '../lib/translation';
import { DailyProgramCta } from './dailyProgram';
import { Reservable } from './reservable';

export const DefaultEventDisplayOption = 'show-finish-time';
export type EventDisplayOption =
  | 'show-as-24/7'
  | 'show-finish-time'
  | 'do-not-show-finish-time'
  | 'ends-late'
  | 'override-start-time';

export type StrategicLibraryTransfer = 'promote-to-brand' | 'add-property-to-access';

export interface BareEventPropertyInfo {
  property: string;
  defaultStaffAllocations: BareStaffAllocation[]; // Per property default staff allocation
}

export interface NewEventTemplate {
  title: string;
  description: string;

  segment?: string;
  levels: string[];
  attributes: string[];

  incomplete: boolean;
  defaultDuration: number; // In minutes

  brand: string;
  properties: BareEventPropertyInfo[];

  source?: string;
  mcm?: Mcm;
  audience?: Audience;

  images: string[];
  softConflict: boolean;
  isPrivate: boolean;
  crewOnly?: boolean;
  notNative?: boolean;

  interactiveFeedDisplay: EventDisplayOption;
  archived?: boolean;

  // VV fields
  inventoried?: boolean;
  initialInventory?: number;
  priced?: boolean;
  initialPrice?: number;
  vip?: boolean;
  simple?: boolean;
  homecoming?: boolean;
  allAboard?: boolean;

  shortCode?: string; // Used for packageTypes at VV

  callToActions: DailyProgramCta[];
  reservables?: Reservable;
}

export type BareEventTemplate = NewEventTemplate & WithId & Partial<WithTimestamp>;

export interface EventTemplate {
  _id: string;
  title: string;
  description: string;

  segment?: BrandSegment;
  levels: BrandLevel[];
  attributes: BrandAttribute[];

  incomplete: boolean;
  defaultDuration: number; // In minutes

  brand: Brand;
  properties: BareEventPropertyInfo[];
  source?: string;
  mcm?: Mcm;
  audience?: Audience;
  reservables?: Reservable;

  images: string[];
  softConflict: boolean;
  isPrivate: boolean;
  crewOnly?: boolean;
  notNative?: boolean;

  interactiveFeedDisplay: EventDisplayOption;
  archived?: boolean;

  // VV fields
  inventoried?: boolean;
  initialInventory?: number;
  priced?: boolean;
  initialPrice?: number;
  vip?: boolean;
  simple?: boolean;
  homecoming?: boolean;
  allAboard?: boolean;

  createdAt?: string;
  updatedAt?: string;
  translations?: EventTemplateTranslation;
  callToActions: DailyProgramCta[];
}

export type EvaluatedEventTemplate = EventTemplate & {
  _evaluatedTitle?: string;
  _evaluatedDesc?: string;
};

export type PaginateEventTemplateParams = BasePaginationAndSearch<BareEventTemplate> & {
  propertyId?: string;
  archived?: boolean;
  startDate?: string;
  endDate?: string;
} & BaseTranslationAggregationParams;
